import React, {useCallback, useMemo} from "react";
import {useNavigate} from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DonutsCard from "./sub-components/donutCards";
import {ToQuickListSkeleton} from "./sub-components/skeleton";

const ToQuickList = ({
                         currentPage,
                         startDate,
                         endDate,
                         setCurrentPage,
                         allScreenList,
                         isScreeningLoading,
                     }) => {
    const navigate = useNavigate();

    const handleChangePage = useCallback(() => {
        setCurrentPage((prev) => prev + 1);
    }, [setCurrentPage]);

    const handleNavigate = useCallback((user) => {
        navigate('/quick-list/details-view', {state: {user, startDate, endDate}});
    }, [navigate, startDate, endDate]);

    const users = useMemo(() => allScreenList?.users || [], [allScreenList]);
    const totalCount = allScreenList?.totalCount ?? 0;

    if (isScreeningLoading) {
        return (
            <>
                <p className="secondHeader">Quick List</p>
                <Row>
                    <ToQuickListSkeleton/>
                </Row>
            </>
        )
    }

    if (!users.length) {
        return (
            <>
                <p className="secondHeader">Quick List</p>
                <Row>
                    <img
                        alt="No data found"
                        src="no-data.gif"
                        style={{
                            width: "200px",
                            display: "block",
                            margin: "0 auto",
                            objectFit: "contain",
                        }}
                    />
                </Row>
            </>
        );
    }

    return (
        <>
            <p className="secondHeader">Quick List</p>
            <Row>
                {users.map((user, i) => (
                    <Col
                        xl={4}
                        xxl={4}
                        lg={4}
                        md={6}
                        xs={12}
                        sm={12}
                        key={user.id || i}
                        onClick={() => {
                            handleNavigate(user)
                        }}
                        style={{cursor: "pointer"}}
                    >
                        <DonutsCard left="Daily Average" last="High Score" user={user}/>
                    </Col>
                ))}

                {users.length < totalCount && (
                    <p
                        className="secondHeader"
                        style={{cursor: "pointer"}}
                        onClick={handleChangePage}
                    >Load More</p>
                )}
            </Row>
        </>
    );
};


export default ToQuickList;
// checked
